import { create } from 'zustand';

export type BillingDialog =
  | 'subscriptionWizard'
  | 'downgrade'
  | 'resumeSubscription'
  | 'addSubAccount'
  | 'enableTeamBilling'
  | 'upgradeRequired'
  | 'addonRequired'
  | 'screenManagement'
  | 'addonUpdate'
  | 'unpaidInvoices'
  | 'billingInformation';

interface BillingDialogState {
  activeDialog: BillingDialog | null;
  dialogContext: Record<string, unknown>;
  openDialog: (dialog: BillingDialog, context?: Record<string, unknown>) => void;
  closeDialog: () => void;
}

export const useBillingDialogStore = create<BillingDialogState>((set) => ({
  activeDialog: null,
  dialogContext: {},
  openDialog: (dialog, context = {}) => set({ activeDialog: dialog, dialogContext: context }),
  closeDialog: () => set({ activeDialog: null, dialogContext: {} }),
}));

/** Open the subscription wizard in upgrade mode — skips to plan step, filters plans >= minPlan */
export function openUpgradeWizard(minPlanRequired: string) {
  useBillingDialogStore.getState().openDialog('subscriptionWizard', {
    preSelectedPlan: minPlanRequired,
    minPlanRequired,
  });
}
